export const credits = {
  "Corporate Board": [
      { staff_name: "Shea Vance", title: "Editor in Chief" },
      { staff_name: "Heather Chen", title: "Managing Editor" },
      { staff_name: "Albert Tsai", title: "Publisher" }
  ],
  "Engineering": [
      { staff_name: "Noel Negron", title: "Head of Engineering" }
  ],
  "Sports": [
      { staff_name: "Arielle Rieder", title: "Sports Editor" },
      { staff_name: "Jillian Prunty", title: "Sports Editor" },
      { staff_name: "Lucas Metzger", title: "Deputy Sports Editor" },
      { staff_name: "Ashley Flores", title: "Deputy Sports Editor" },
      { staff_name: "Nicholas Fink", title: "Deputy Sports Editor" },
      { staff_name: "Benjamin Rubin", title: "Staff Writer" },
      { staff_name: "Kaya Quebada", title: "Staff Writer" },
      { staff_name: "Andrew Vincenti", title: "Staff Writer" },
      {staff_name: "Olivia Madkins", title:"Staff Writer"}
  ],
  "Copy": [
      { staff_name: "Posey Chiddix", title: "Head Copy Editor" },
      { staff_name: "Eli Trokenheim", title: "Deputy Copy Editor" },
      { staff_name: "Em Spencer", title: "Deputy Copy Editor" },
      { staff_name: "Diego Carvajal Núñez", title: "Deputy Copy Editor" },
      { staff_name: "Reese Ransweiler", title: "Deputy Copy Editor" },
      { staff_name: "Vaishu Sirkay", title: "Deputy Copy Editor" }
  ],
  "Illustrations": [
      { staff_name: "Conner Sund", title: "Illustrations Editor" },
      { staff_name: "Anaïs Fotsing", title: "Deputy Illustrations Editor" },
      { staff_name: "Saumya Chaudhry", title: "Deputy Illustrations Editor" },
      { staff_name: "Kelsea Petersen", title: "Senior Staff Illustrator" }
  ],
  "Photo": [
      { staff_name: "Stella Ragas", title: "Photo Editor "  },
      { staff_name: "Esmeralda Paredes", title: "Deputy Photo Editor" },
      { staff_name: "Salem Maru", title: "Deputy Photo Editor" }
  ],
  "Video": [
      { staff_name: "Elliot Heath", title: "Video Editor" }
  ],
  "Product": [
      { staff_name: "Daniela Velazquez", title: "Head of Product" },
      { staff_name: "Melinda Yao", title: "Product Deputy" }
  ],
  "Graphics":[
    {   staff_name:	"Jenny Ye"	, title: "Graphics Editor"},
    {   staff_name:	"Alison Chiu"	, title: "Graphics Reporter"},
    {   staff_name:	"Emilia Lebeau"	, title: "Graphics Reporter"}
  ]
};
